import { useTranslations } from "next-intl"
import { useNavigationContent } from "@/features/navigation/hooks/useNavigationContent"
import { externalRoutesPaths } from "@/routes/external"
import { storyblokRoutesPaths } from "@/routes/storyblok"
import { type MenuItem } from "../types/menuItem"

/** Hardcoded menu, used until Storyblok has usable content. */
function getDefaultCenterMenu(t: ReturnType<typeof useTranslations>) {
    return [
        {
            label: t("about"),
            href: storyblokRoutesPaths.landing.resolve({
                pathParams: { landingId: "qui-sommes-nous" },
            }),
        },
        {
            label: t("greenEnergy"),
            href: storyblokRoutesPaths.greenEnergy.resolve(),
        },
        {
            label: t("contact"),
            href: storyblokRoutesPaths.landing.resolve({ pathParams: { landingId: "contact" } }),
        },
        {
            label: t("backOfficeB2BG"),
            href: externalRoutesPaths.backOfficeB2BG.resolve(),
        },
        {
            label: t("pressArea"),
            href: storyblokRoutesPaths.pressArea.resolve(),
        },
        {
            label: t("legal"),
            href: storyblokRoutesPaths.landing.resolve({ pathParams: { landingId: "legal" } }),
        },
    ] satisfies Array<MenuItem>
}

export function useCenterMenu(): Array<MenuItem> {
    const t = useTranslations("useCenterMenu")
    const { footerCenterMenu } = useNavigationContent()

    const items = footerCenterMenu.length ? footerCenterMenu : getDefaultCenterMenu(t)

    return [
        ...items,
        {
            // Opens the Didomi panel, so it has no href and cannot be authored
            // in Storyblok. Always last.
            label: t("cookies"),
            onClick: () => window?.Didomi.preferences.show(),
        },
    ]
}

useCenterMenu.messages = ["useCenterMenu"] as const
